<template>
    <div
        class="modal fade"
        :id="`myModal${id}_1`"
        tabindex="-1"
        role="dialog"
        :aria-labelledby="`myModalLabel${id}_1`"
        aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" :id="`myModalLabel${id}_1`">
                        預定完成日
                    </h4>
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-hidden="true"
                    >
                        X
                    </button>
                </div>
                <div class="modal-body">
                    <table class="table table-bordered table-hover">
                        <tr>
                            <th class="tr-bg text-nowrap" data-priority="1">
                                接收日期
                            </th>
                            <td class="text-nowrap">{{ actStartDay }}</td>
                        </tr>
                        <tr>
                            <th class="tr-bg text-nowrap" data-priority="2">
                                預定完成日期
                            </th>
                            <td class="text-nowrap">{{ estEndDay }}</td>
                        </tr>
                        <tr>
                            <th class="tr-bg text-nowrap" data-priority="3">
                                實際完成日期
                            </th>
                            <td class="text-nowrap">{{ actEndDay }}</td>
                        </tr>
                    </table>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn clear-btn"
                        data-dismiss="modal"
                    >
                        關閉
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: [String, Number],
            default: ""
        },
        actStartDay: {
            type: String,
            default: ""
        },
        estEndDay: {
            type: String,
            default: ""
        },
        actEndDay: {
            type: String,
            default: ""
        }
    },
    mounted() {
        // console.log(this.actStartDay);
        // console.log(this.estEndDay);
        // console.log(this.actEndDay);
    }
};
</script>
